import React from 'react';
import { Row, Col, Modal, Button, Divider, Form } from 'antd';
import useForm from '../hooks/useForm';
import { SelectWhatsappModule } from 'components/select';
import { useParams } from "react-router-dom";

const ModalForm = ({ data = {}, visible, hideModal, fetchTable }) => {
    const { id } = useParams();
    const [form] = Form.useForm(); // initialize form

    const {
        values,
        loading,
        handleSubmit,
    } = useForm(data, fetchTable, hideModal, id);

    return (
        <Modal
            maskClosable={false}
            keyboard={false}
            title="Form WhatsApp Service"
            open={visible}
            onCancel={hideModal}
            closable={false}
            footer={null}
        >
            <Form
                form={form}
                name="whatsappServiceForm"
                autoComplete="off"
                layout="vertical"
                onFinish={handleSubmit}
                loading={loading}
                initialValues={values}
            >
                <Row gutter={[16, 0]}>
                    <Col xs={24}>

                        <Form.Item
                            label="Module"
                            name="whatsapp_modul_ids"
                            rules={[{ required: true, message: 'Module wajib diisi!' }]}
                        >
                            <SelectWhatsappModule
                                allowclear
                                mode="multiple" />
                        </Form.Item>

                    </Col>

                    <Col xs={24}>
                        <Divider />
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                            <Button onClick={hideModal} disabled={loading}>Batal</Button>
                            <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                                Simpan
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default ModalForm;
